<ng-container *ngIf="data.version!=2; else version2">
    <span *ngIf="user.status==0" class="clap"
        (click)="global.trackEvent('total-clap', for + ' ' + from + ' clap-login', slug); dialog.openLoginDialog(1,'action','clap', '', {'for':'clap','type':for,'slug':slug}); localClapGuide=true;">

        <img style="align-items:center"
            [lazyLoad]="(from=='player')?'https://songdewnetwork.com/sgmedia/assets/images/clap-white.png':'../../assets/images/clap.svg'"
            alt="Like: {{slug}}">
        <!--span id="clapCount" class="clapCount">{{clapsCount}}</span-->
        <!--span id="clapCountTotal" class="clapCountTotal">{{totalClapsCount}}
            {{(totalClapsCount==1)?'Clap':'Claps'}}</span -->
    </span>

    <span *ngIf="user.status!=0" class="clap relative" (contextmenu)="onRightClick($event)"
        (mousedown)="mouseDown($event)" (mouseup)="mouseUp($event)" [ngClass]="{'active': clapAnimationEffect}"
        (click)="removeGuide()">

        <img style="align-items:center"
            [class.filter-max-brightness]="(from=='player' || from=='widget') && !clapsCount>0"
            [lazyLoad]="clapsCount>0 ? ((from=='player' || from=='widget') ? 'https://songdewnetwork.com/sgmedia/assets/images/clap3.png' : '../../../assets/images/clapping5.svg'):'../../assets/images/clap.svg'"
            alt="Like: {{slug}}">
        <!--span id="clapCount" class="clapCount">{{clapsCount}}</span -->
        <!--span id="clapCountTotal" class="clapCountTotal"><span *ngIf="from!='player'"
                class='clapsCountTotal_{{slug}}'>{{totalClapsCount}}</span>
            {{(totalClapsCount==1)?'Clap':'Claps'}}</span-->
    </span>
</ng-container>
<ng-template #version2>
    <ng-container *ngIf="data.disabled=='true'; else nondisabled">
        <span class="claps">
            <img style="vertical-align:middle" src="../../../assets/images/clapping-5.svg">
            <!--span id="clapCountTotal" class="clapCountTotal">{{totalClapsCount}}
                {{(totalClapsCount==1)?'Clap':'Claps'}}</span-->
        </span>
    </ng-container>
    <ng-template #nondisabled>
        <ng-container *ngIf="data.clapsonly=='true'; else clapcounter">
            <span *ngIf="user.status==0" class="clap"
                (click)="global.trackEvent('total-clap', for + ' ' + from + ' clap-login', slug); dialog.openLoginDialog(1,'action','clap', '', {'for':'clap','type':for,'slug':slug}); localClapGuide=true;">
                <img style="vertical-align:middle;margin-right:0"
                    [lazyLoad]="(from=='player')?'https://songdewnetwork.com/sgmedia/assets/images/clap-white.png':'../../assets/images/clap.svg'"
                    alt="Like: {{slug}}">
                <!--span id="clapCount" class="clapCount">{{clapsCount}}</span-->
                
            </span>
            <span *ngIf="user.status!=0" class="clap" (contextmenu)="onRightClick($event)"
                (mousedown)="mouseDown($event)" (mouseup)="mouseUp($event)" [ngClass]="{'active': clapAnimationEffect}"
                (click)="removeGuide()">
                <img style="vertical-align:middle;margin-right:0" class="hover"
                    [class.filter-max-brightness]="(from=='player' || from=='widget') && !clapsCount>0"
                    [lazyLoad]="clapsCount>0 ? ((from=='player' || from=='widget') ? 'https://songdewnetwork.com/sgmedia/assets/images/clap3.png' : '../../assets/images/clapping5.svg'):'../../assets/images/clap.svg'"
                    alt="Like: {{slug}}">
                <!--span id="clapCount" class="clapCount">{{clapsCount}}</span-->
         
            </span>
        </ng-container>
        <ng-template #clapcounter>
            <span *ngIf="user.status==0" class="clap"
                (click)="global.trackEvent('total-clap', for + ' ' + from + ' clap-login', slug); dialog.openLoginDialog(1,'action','clap', '', {'for':'clap','type':for,'slug':slug}); localClapGuide=true;">
                <img style="vertical-align:middle"
                    [lazyLoad]="(from=='player')?'https://songdewnetwork.com/sgmedia/assets/images/clap-white.png':'../../assets/images/clap.svg'"
                    alt="Like: {{slug}}">
                <!--span id="clapCount" class="clapCount">{{clapsCount}}</span-->
                <!--span id="clapCountTotal" class="clapCountTotal">{{totalClapsCount}}
                    {{(totalClapsCount==1)?'Clap':'Claps'}}</span-->
            
            </span>
            <span *ngIf="user.status!=0" class="clap" (contextmenu)="onRightClick($event)"
                (mousedown)="mouseDown($event)" (mouseup)="mouseUp($event)" [ngClass]="{'active': clapAnimationEffect}"
                (click)="removeGuide()">
                <img style="vertical-align:middle"
                    [class.filter-max-brightness]="(from=='player' || from=='widget') && !clapsCount>0"
                    [lazyLoad]="clapsCount>0 ? ((from=='player' || from=='widget') ? 'https://songdewnetwork.com/sgmedia/assets/images/clap3.png' : '../../../assets/images/clapping5.svg'):'../../assets/images/clap.svg'"
                    alt="Like: {{slug}}">
                <!-- span id="clapCount" class="clapCount">{{clapsCount}}</span -->
                <!--span id="clapCountTotal" class="clapCountTotal"><span *ngIf="from!='player'"
                        class='clapsCountTotal_{{slug}}'>{{totalClapsCount}}</span>
                    {{(totalClapsCount==1)?'Clap':'Claps'}}</span-->
            </span>
        </ng-template>

    </ng-template>
</ng-template>
